export default "__VITE_ASSET__yiWcR$gE__"